module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-70x70-79ab1cc37f448a727ae263c8c481a5a9.png";